<template>
  <v-col cols="12" class="pb-0 pt-1 mx-1">
    <v-row>
      <v-subheader class="pa-1">Horaire de tavail</v-subheader>
      <v-col cols="12" class="py-0 px-1">
        <div v-for="item in openningHoursLocal" :key="item.day">
          <p
            class="subtitle-1 font-weight-bold ma-0"
            style="display: inline-block;"
          >{{days[item.day]}}</p>
          <p
            class="font-italic font-weight-light text--secondary px-2 ma-0"
            style="display: inline-block;"
          >de</p>
          <!-- item begin -->
          <p style="display: inline-block;" class="ma-0">{{item.begin | hours}}</p>
          <p
            class="font-italic font-weight-light text--secondary px-2 ma-0"
            style="display: inline-block;"
          >jusqu'à</p>
          <!-- item end -->
          <p style="display: inline-block;" class="ma-0">{{item.end | hours}}</p>
        </div>
      </v-col>
      <v-col class="py-0 px-1" cols="12" md="3">
        <v-combobox
          color="secondary"
          :items="days"
          label="Jours"
          :error-messages="daysError"
          v-model="opHours.day"
        ></v-combobox>
      </v-col>
      <v-col class="py-0 px-1" cols="12" md="3">
        <v-combobox color="secondary" :items="hours" label="de" v-model="opHours.begin"></v-combobox>
      </v-col>
      <v-col class="py-0 px-1" cols="12" md="3">
        <v-combobox color="secondary" :items="hours" label="jusqu'à" v-model="opHours.end"></v-combobox>
      </v-col>
      <v-col class cols="12" md="3">
        <v-btn outlined color="secondary" @click="addOpHours">Ajouter</v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import moment from "moment";

export default {
  props: ["openningHours"],
  data() {
    return {
      days: [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi"
      ],
      opHours: {},
      daysError: null,
    };
  },
  computed: {
    openningHoursLocal: {
      get() {
        return this.openningHours || [];
      },
      set(value) {
        this.$emit("update:openningHours", value);
      },
    },
    hours: () => {
      let hours = [];
      for (let i = 420; i < 1350; i += 30) {
        hours.push(moment().startOf("day").add(i, "minutes").format("HH:mm"));
      }
      return hours;
    },
  },
  methods: {
    addOpHours() {
      if (
        this.openningHoursLocal.filter((e) => {
          return e.day === this.days.indexOf(this.opHours.day);
        }).length > 0
      ) {
        return (this.daysError = "Déja ajouté");
      }
      if (this.opHours.begin && this.opHours.end && this.opHours.day) {
        this.opHours.begin =
          parseInt(this.opHours.begin.substr(0, 2), 10) * 60 +
          parseInt(this.opHours.begin.substr(3, 2), 10);
        this.opHours.end =
          parseInt(this.opHours.end.substr(0, 2), 10) * 60 +
          parseInt(this.opHours.end.substr(3, 2), 10);
        this.opHours.day = this.days.indexOf(this.opHours.day);
        this.openningHoursLocal.push({ ...this.opHours });

        this.opHours = {};
        this.daysError = null;
      }
    },
  },
};
</script>